import TransactionDetailsComponent from './TransactionDetailsComponent';

export default TransactionDetailsComponent;